import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusUpdateInterface } from "../../models/interfaces/update-status.interface";

export interface ActiveApplicationsInterface {
  activeApplications: StatusUpdateInterface[];
}

const initialState: ActiveApplicationsInterface = {
  activeApplications: [],
};

const ActiveApplicationsSlice = createSlice({
  name: "Active Applications Slice",
  initialState,
  reducers: {
    setActiveApplications: (
      state,
      action: PayloadAction<StatusUpdateInterface[]>
    ) => {
      state.activeApplications = action.payload;
    },
  },
  extraReducers: {},
});

export const { setActiveApplications } = ActiveApplicationsSlice.actions;

export default ActiveApplicationsSlice.reducer;
